import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { Token } from '@frontend/authentication-v2';
import { BasketItem, BasketItemListResponse, BasketItemQueryParams, CreateBasketItem, UpdateBasketItem } from '@frontend/basket/types';

export class BasketItemClient extends APIClient {
    public static readonly endpoint = '/basket-api/v1';

    public static async fetchBasketItems(queryParams?: ApiQueryParams<BasketItemQueryParams>): Promise<BasketItemListResponse> {
        return await this.apiPaginated<BasketItemListResponse, BasketItemQueryParams>(`${this.endpoint}/basket-items`, queryParams);
    }

    public static async resolveBasketItems(ids: string[], field: string = 'id'): Promise<BasketItemListResponse> {
        return this.resolve<BasketItemListResponse>(`${this.endpoint}/basket-items`, ids, field);
    }

    public static async deleteBasketItems(ids: string): Promise<void> {
        const response = await this.post(`${this.endpoint}/basket-items-delete`, { ids });
        return await this.handleVoidResponse(response);
    }

    public static async postBasketItem(accountId: string, basketId: string, basketItem: CreateBasketItem, withToken?: Token): Promise<BasketItem> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/baskets/${basketId}/items`, basketItem, true, withToken);
        return await this.handleResponse<BasketItem>(response);
    }

    public static async fetchBasketItem(accountId: string, basketId: string, basketItemId: string): Promise<BasketItem> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/baskets/${basketId}/items/${basketItemId}`);
        return await this.handleResponse<BasketItem>(response);
    }

    public static async patchBasketItem(accountId: string, basketId: string, basketItemId: string, basketItem: UpdateBasketItem): Promise<BasketItem> {
        const response = await this.patch(`${this.endpoint}/accounts/${accountId}/baskets/${basketId}/items/${basketItemId}`, basketItem);
        return await this.handleResponse<BasketItem>(response);
    }

    public static async deleteBasketItem(accountId: string, basketId: string, basketItemId: string): Promise<void> {
        const response = await this.delete(`${this.endpoint}/accounts/${accountId}/baskets/${basketId}/items/${basketItemId}`);
        return await this.handleVoidResponse(response);
    }
}
